import { useEffect, useRef } from "react";

export function Bubbles({ count = 14, dark = false }) {
  const bubbles = useRef(
    Array.from({ length: count }).map((_, i) => {
      const size = 6 + Math.random() * 34;
      return {
        id: i,
        size,
        left: Math.random() * 100,
        duration: 12 + Math.random() * 20,
        delay: Math.random() * 18,
      };
    })
  );
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {bubbles.current.map((b) => (
        <span
          key={b.id}
          className="fn-bubble animate-float-up"
          style={{
            width: b.size,
            height: b.size,
            left: `${b.left}%`,
            animationDuration: `${b.duration}s`,
            animationDelay: `${b.delay}s`,
            borderColor: dark ? "rgba(217,179,64,0.35)" : "rgba(255,255,255,0.5)",
            background: dark ? "rgba(163,140,224,0.06)" : "rgba(255,255,255,0.08)",
          }}
        />
      ))}
    </div>
  );
}

export function WaveDivider({ color = "#F9F6F0", flip = false }) {
  return (
    <div className="relative w-full leading-[0]" style={{ transform: flip ? "rotate(180deg)" : "none" }} aria-hidden="true">
      <svg viewBox="0 0 1440 90" preserveAspectRatio="none" className="w-full h-[60px] md:h-[90px]">
        <path
          fill={color}
          d="M0,40 C240,90 480,0 720,30 C960,60 1200,10 1440,45 L1440,90 L0,90 Z"
        />
      </svg>
    </div>
  );
}

export function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const els = ref.current?.querySelectorAll("[data-reveal]") || [];
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.style.opacity = 1;
            e.target.style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el, i) => {
      el.style.opacity = 0;
      el.style.transform = "translateY(24px)";
      el.style.transition = `opacity 0.7s ease ${(i % 6) * 0.06}s, transform 0.7s ease ${(i % 6) * 0.06}s`;
      io.observe(el);
    });
    return () => io.disconnect();
  }, []);
  return ref;
}
